const isBulletLine = line => /^[-•*]\s+/.test(line)
const isNumberedLine = line => /^\d+\.\s+/.test(line)
const isShortPlainLine = line =>
  line.length >= 3 && line.length < 50 && !/[.!?:]$/.test(line) && !isBulletLine(line) && !isNumberedLine(line)

// Divide el texto en bloques: títulos numerados (h2), subtítulos
// (h3, líneas cortas o que acaban en ":"), listas (viñetas "-•*", o
// 3+ líneas cortas seguidas sin viñeta) y párrafos normales.
export function parsePlanBlocks(contenido) {
  const lines = (contenido || '').split('\n').map(l => l.trim())
  const blocks = []
  let i = 0

  while (i < lines.length) {
    const line = lines[i]

    if (isBulletLine(line)) {
      const items = []
      while (i < lines.length && isBulletLine(lines[i])) {
        const item = lines[i].replace(/^[-•*]\s+/, '').trim()
        if (item) items.push(item)
        i++
      }
      blocks.push({ type: 'list', items })
      continue
    }

    if (!line || /^[-•*]$/.test(line)) { blocks.push({ type: 'space' }); i++; continue }

    if (isNumberedLine(line)) {
      blocks.push({ type: 'h2', text: line })
      i++; continue
    }

    if (isShortPlainLine(line)) {
      const group = [line]
      let j = i + 1
      while (j < lines.length && isShortPlainLine(lines[j])) { group.push(lines[j]); j++ }
      if (group.length >= 3) blocks.push({ type: 'list', items: group })
      else for (const g of group) blocks.push({ type: 'h3', text: g })
      i = j
      continue
    }

    if (/:$/.test(line) && line.length < 70) {
      blocks.push({ type: 'h3', text: line })
      i++; continue
    }

    blocks.push({ type: 'p', text: line })
    i++
  }

  return blocks
}

// Divide una línea de texto en tramos {text, bold}, detectando
// *negrita* o **negrita**.
export function parseInlineSegments(text) {
  const segments = []
  const regex = /\*\*(.+?)\*\*|\*(.+?)\*/g
  let lastIndex = 0
  let m
  while ((m = regex.exec(text)) !== null) {
    if (m.index > lastIndex) segments.push({ text: text.slice(lastIndex, m.index), bold: false })
    segments.push({ text: m[1] ?? m[2], bold: true })
    lastIndex = regex.lastIndex
  }
  if (lastIndex < text.length) segments.push({ text: text.slice(lastIndex), bold: false })
  return segments.length ? segments : [{ text, bold: false }]
}
